/**
 * Store the values as static and once the values are read from local storage, save it here.
 * When the user updates the User Settings we are setting it to null.
 */
export class UserPreferencesHelper {
  static userViewOptions;

  /**
   * Read from local storage and set the viewOptions
   */
  static getUserViewOptions() {
    const userProfileSettings = localStorage.getItem('USER_SETTINGS')
      ? JSON.parse(localStorage.getItem('USER_SETTINGS'))
      : null;
    // NOTE: the user settings is being stored as { userSettings },
    // as many places uses it with this structure. To change it, we need
    // to modify some utility functions
    if (userProfileSettings?.userSettings?.viewOptions != null) {
      const { userSettings } = userProfileSettings;
      const { viewOptions } = userSettings;
      UserPreferencesHelper.userViewOptions = viewOptions;
    } else {
      UserPreferencesHelper.userViewOptions = { rents: null, globalDateFormat: null };
    }
  }
}

/**
 * Safely return if the user rent preference is yearly
 *
 * @return true by default or if user rent settings is yearly
 */
export const isYearlyPreference = () => {
  if (UserPreferencesHelper.userViewOptions == null || UserPreferencesHelper.userViewOptions.rents == null) {
    UserPreferencesHelper.getUserViewOptions();
  }
  const { rents } = UserPreferencesHelper.userViewOptions;
  const rentsOpt = !!rents && rents.length > 0 ? rents[0] : null;
  // define display preference (by default is yearly)
  return !!rentsOpt ? !!rentsOpt && rentsOpt.code === 'Yearly' : true;
};

/**
 * @param key Using key we decide whether to use code or value from the saved user preference
 * @return string - Display Format of Date
 */

export const getGlobalDateDisplayFormat = (key: string = 'code', extended = false): string => {
  if (UserPreferencesHelper.userViewOptions == null || UserPreferencesHelper.userViewOptions.globalDateFormat == null) {
    UserPreferencesHelper.getUserViewOptions();
  }
  const { globalDateFormat } = UserPreferencesHelper.userViewOptions;
  const dateOpt = !!globalDateFormat && globalDateFormat.length ? globalDateFormat[0] : null;
  if (!!dateOpt) {
    return (extended && `${dateOpt[key]} h:mm:ss a`) || dateOpt[key];
  }
  return key !== 'code'
    ? (extended && 'MM/DD/YYYY h:mm:ss a') || 'MM/DD/YYYY'
    : (extended && 'M/d/yyyy h:mm:ss a') || 'M/d/yyyy';
};
